import { Select, MenuItem, FormControl, InputLabel } from '@mui/material';
import _ from 'lodash';
import { ECompanyType } from '../../models/company.model';

type Props = {
  value: ECompanyType;
  onChange?: (value: ECompanyType) => void;
  margin?: 'none' | 'dense' | 'normal' | undefined;
};

const CompanyTypeSelect = (props: Props) => {
  const dropdownItems = Object.values(ECompanyType);

  return (
    <FormControl fullWidth margin={props.margin}>
      <InputLabel>Type</InputLabel>
      <Select
        size="small"
        label="Type"
        value={props.value}
        onChange={(e) => {
          const item = dropdownItems.find((i) => i === e.target.value);
          if (item) {
            props.onChange?.(item);
          }
        }} // Handle select change here
        displayEmpty
        renderValue={(selected) => {
          return _.capitalize(_.words(selected).join(' '));
        }}
      >
        {dropdownItems.map((item) => (
          <MenuItem key={item} value={item}>
            {_.capitalize(_.words(item).join(' '))}
          </MenuItem>
        ))}
      </Select>
    </FormControl>
  );
};

export default CompanyTypeSelect;
